import client from "@irati/utils/services/apollo"

import {askNicelyEmailHash} from "./queries"

class AskNicelyService {
  getEncodedEmail(email: string): String {
    return client
      .query({
        query: askNicelyEmailHash,
        variables: {
          email
        }
      })
      .then((res) => {
        return res.data.askNicelyEmailHash
      })
  }
}

const service = new AskNicelyService()

export default service
